import { Customer, Order, PaginatedResult, CustomerHistory } from "../models";
import { ServiceResponse, FetchService, PaginationParams } from "../shared";
import ServicePaths from "./ServicePaths";

export default class CustomerService {
    public static OrderOptions(): Promise<ServiceResponse<Customer>> {
        return FetchService.get<Customer>({
            url: ServicePaths.ORDER_OPTIONS,
        });
    }

    public static CreateOrder(data: Order): Promise<ServiceResponse<Order>> {
        return FetchService.post<Order>({
            url: ServicePaths.ORDERS,
            body: data,
        });
    }

    public static My(): Promise<ServiceResponse<Customer>> {
        return FetchService.get<Customer>({
            url: ServicePaths.MY,
        });
    }

    public static GetHistory(
        pageIndex: number,
        createdDateFrom?: Date,
        createdDateTo?: Date,
        menuId?: number,
        menuTypeCode?: string
    ): Promise<ServiceResponse<PaginatedResult<CustomerHistory>>> {
        let extra = "";
        if (menuId) extra += `menuId=${menuId}`;
        if (menuTypeCode) extra += `menuTypeCode=${menuTypeCode}`;

        const params = new PaginationParams();
        params.pageIndex = pageIndex;
        params.createdDateFrom = createdDateFrom;
        params.createdDateTo = createdDateTo;
        params.extraParams = extra;

        return FetchService.get<PaginatedResult<CustomerHistory>>({
            url: ServicePaths.HISTORY,
            paginationParams: params,
        });
    }
}
